import {
  ADMIN_SET_UI,
  ADMIN_SET_ERROR,
  ADMIN_SET_LOGIN_TOKEN,
  ADMIN_LOGIN_SUCCESS,
  ADMIN_LOGIN_FAILURE,
} from '../constants/admin/adminActions'
import { AdminUI } from '../constants/admin/adminUi'

interface State {
  adminUiState: AdminUI
  error?: string
  token: string
}
const initialState: State = { adminUiState: AdminUI.LOGIN, error: '', token: '' }
const reducer = (state: State = initialState, action: any) => {
  switch (action.type) {
    case ADMIN_SET_UI: {
      const adminUiState = action.payload || AdminUI.LOGIN
      return { ...initialState, adminUiState }
    }
    case ADMIN_SET_ERROR: {
      const error = action.payload || 'error'
      return { ...initialState, adminUiState: AdminUI.ERROR, error }
    }
    case ADMIN_SET_LOGIN_TOKEN:
      return { ...state, token: action.payload }
    case ADMIN_LOGIN_SUCCESS:
      return { ...initialState, adminUiState: AdminUI.ALL_TERMINALS }
    case ADMIN_LOGIN_FAILURE:
      return { ...initialState, adminUiState: AdminUI.LOGIN }
    default:
      return state
  }
}

export default reducer
